<template>
  <search-dropdown
    :oneLine="true"
    :options="this.options"
    :value="this.sort"
    name="searchSort"
    placeholder="Sortera efter: "
    @changed="updateSort"
    @inputChange="updateSort"
  ></search-dropdown>
</template>

<script>
import SearchDropdown from './SearchDropdown'
import { SET_SORT } from '@/store/actionTypes'
import { mapState } from 'vuex'

export default {
  name: 'SearchSort',

  components: {
    SearchDropdown
  },

  data() {
    return {
      options: [
        {
          name: 'Relevans',
          path: 'relevance',
          value: 'relevance'
        },
        {
          name: 'Yrkeserfarenhet',
          path: 'experiences',
          value: 'experiences'
        },
        {
          name: 'Utbildning',
          path: 'educations',
          value: 'educations'
        },
        {
          name: 'Kompetenser',
          path: 'skills',
          value: 'skills'
        }
      ]
    }
  },

  computed: {
    ...mapState({
      sort: state => state.sort
    })
  },

  methods: {
    updateSort({ value }) {
      this.$store.commit(SET_SORT, value)
    }
  }
}
</script>

<style lang="postcss" scoped>

</style>



// WEBPACK FOOTER //
// src/views/Search/SearchSort.vue